import { CursorType, ModalType } from "@/store/globalSettingsSlice";

export interface DesignToolShortcut {
  key: string;
  toolName: string;
  cursorType?: CursorType;
  modalType?: ModalType;
  description: string;
}

export const DESIGN_TOOLBAR_SHORTCUTS: Record<string, DesignToolShortcut> = {
  AI: {
    key: "a",
    toolName: "AI",
    modalType: ModalType.AI,
    description: "AI tool",
  },
  DRAW: {
    key: "f",
    toolName: "Draw",
    cursorType: CursorType.Draw,
    description: "Draw tool",
  },
  SELECT: {
    key: "v",
    toolName: "Select",
    cursorType: CursorType.Pointer,
    description: "Select tool",
  },
  TEXT: {
    key: "t",
    toolName: "Text",
    cursorType: CursorType.Text,
    description: "Text tool",
  },
  HAND: {
    key: "h",
    toolName: "Hand tool",
    cursorType: CursorType.Pan,
    description: "Hand tool",
  },
  GENERATE_IMAGE: {
    key: "g",
    toolName: "Generate Image",
    modalType: ModalType.Image,
    description: "Generate image",
  },
  TOGGLE_DARK_LIGHT_MODE: {
    key: "x",
    toolName: "Light/Dark mode",
    description: "Switch to light/dark mode",
  },
  DESIGN_INTERACT_MODE: {
    key: "d",
    toolName: "Design/Interactive mode",
    description: "Design/Interactive mode",
  },
};

export const getTooltipContent = (
  toolName: string,
  shortcut: string,
): string => {
  const key = shortcut.toUpperCase();
  return `<span class="opacity-90">${toolName}</span><span class="inline-block w-1.5" aria-hidden="true"></span><span class="ml-2 rounded bg-white/8 text-white tracking-wide">${key}</span>`;
};
